import { Component, ElementRef, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Seller } from "../../../objects/amazon/seller";
import { UserService } from "../../../services/userService";
import { AmazonStoreCredentials } from "../../../objects/amazon/AmazonStoreCredentials";
import { AmazonService } from "../../../services/amazon.service";
import { ActivatedRoute, Router } from "@angular/router";
import * as ps from "perfect-scrollbar";
import { ScrollHelper } from "../../../common/helpers/scrollHelper";


@Component({
    selector: 'amazon-info',
    templateUrl: 'amazon-info.component.html',
    moduleId: module.id.toString(),
})

export class AmazonInfoComponent implements OnInit {


    public currentSeller: Seller = new Seller();
    public storeCredentials: AmazonStoreCredentials = new AmazonStoreCredentials();
    public showStoreCredentials: boolean = false;
    @ViewChild("amazonInfo") amazonInfo: ElementRef;
    private body: HTMLElement;

    constructor(private route: ActivatedRoute, public userService: UserService, public amazonService: AmazonService, private renderer: Renderer2, private router: Router) {
    }

    public ngOnInit(): void {

        this.body = document.getElementsByTagName('body')[0];


        if (window.navigator.userAgent.indexOf("Edge") > -1)
            return;



        this.body.classList.add("perfect-scrollbar-on");
        ps.initialize(this.amazonInfo.nativeElement);


    }

    ngAfterViewInit(): void {
        let spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");

        if (window.navigator.userAgent.indexOf("Edge") > -1){
            this.amazonInfo.nativeElement.style["height"]='auto';
            ScrollHelper.forceSetVerticalScroll(this.body);
        }
    }


}


// WEBPACK FOOTER //
// ./app/components/amazon/amazon-info/amazon-info.component.ts